import { Response } from "express";

import { IResultHandler } from "./IResultHandler";

export class CustomContentResultHandler implements IResultHandler {
    private readonly mimeType: string;

    public constructor(mimeType: string) {
        this.mimeType = mimeType;
    }

    public async processResult(result: string, _req: Express.Request, res: Response): Promise<void> {
        res.header("Content-Type", this.mimeType);
        res.send(result.trim());
    }
}
